module.exports = __webpack_public_path__ + "img/9.81db0b98.jpg";